module.exports = __webpack_public_path__ + "static/fonts/BIGJOHN.aa3a008.otf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/BIGJOHN.otf
// module id = wKp8
// module chunks = 1